var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpringWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C12.3 2.5 12.58 2.63 12.77 2.86C13.9 4.23 18 9.36 18 13.5C18 16.81 15.31 19.5 12 19.5C8.69 19.5 6 16.81 6 13.5C6 9.36 10.1 4.23 11.23 2.86C11.42 2.63 11.7 2.5 12 2.5ZM12 5.13C10.57 7 8 10.85 8 13.5C8 15.71 9.79 17.5 12 17.5C14.21 17.5 16 15.71 16 13.5C16 10.85 13.43 7 12 5.13ZM10.2 13.1C10.75 13.1 11.2 13.55 11.2 14.1C11.2 14.83 11.67 15.3 12.4 15.3C12.95 15.3 13.4 15.75 13.4 16.3C13.4 16.85 12.95 17.3 12.4 17.3C10.57 17.3 9.2 15.93 9.2 14.1C9.2 13.55 9.65 13.1 10.2 13.1ZM3 21C3 20.45 3.45 20 4 20H20C20.55 20 21 20.45 21 21C21 21.55 20.55 22 20 22H4C3.45 22 3 21.55 3 21Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringWater);
export default __webpack_public_path__ + "static/media/SpringWater.54e7e170bbf761817efd332b5096c77e.svg";
export { ForwardRef as ReactComponent };